import type { CustomerPrefill } from "@/Components/NextBase/Customer/ManageCustomerBasicInfoModal";

type SubscriptionCoverage = {
  status: string;
  customerSubscriptionServices: { serviceId: number }[];
};

export function getApplicableSubscriptions<T extends SubscriptionCoverage>(
  subscriptions: T[],
  serviceId?: number,
): T[] {
  return subscriptions.filter(
    (sub) =>
      (sub.status === "active" || sub.status === "frozen") &&
      (serviceId == null ||
        sub.customerSubscriptionServices.some(
          (s) => s.serviceId === serviceId,
        )),
  );
}

const PHONE_LIKE = /^\+?[\d\s()/-]+$/;

export function getNewCustomerPrefill(search: string): CustomerPrefill {
  const normalized = search.trim().replace(/\s+/g, " ");
  if (normalized === "") return {};
  if (normalized.includes("@")) return { email: normalized };
  // A phone number needs a country code we can't infer from the search box.
  if (PHONE_LIKE.test(normalized)) return {};

  const [name, ...rest] = normalized.split(" ");
  return { name, lastName: rest.join(" ") };
}

type SubscriptionNaming = {
  name?: string | null;
  variation?: {
    name?: string | null;
    subscription?: { name?: string | null } | null;
  } | null;
};

export function getSubscriptionLabel(sub: SubscriptionNaming): string | null {
  const label = [
    sub.variation?.subscription?.name ?? sub.name,
    sub.variation?.name,
  ]
    .filter(Boolean)
    .join(" - ");
  return label || null;
}

type SubscriptionCredits = {
  credits?: { amount: number; usedAmount: number }[] | null;
};

export function getRemainingCredits(sub: SubscriptionCredits): number {
  return (sub.credits ?? []).reduce(
    (sum, credit) => sum + (credit.amount - credit.usedAmount),
    0,
  );
}
